import React from 'react';
import PropTypes from 'prop-types';
import externalLink from '../images/external-link.svg';
import '../styles/hcHomepageStyles.css';

export const ActivityCard = React.forwardRef((props, ref) => {
    return (
        <div className="activityCard">
            <div className="cardName">
                {props.cardName}
            </div>
            <div className="activityCardCategories">
                <span>{props.activityCardText.grades}:&nbsp;<span>{props.grades}</span></span>
                <span>{props.activityCardText.targetSkills}:&nbsp;<span>{props.targetSkills}</span></span>
                <span>{props.activityCardText.type}:&nbsp;<span>{props.cardTags}</span></span>
            </div>
            <div
                ref={ref} 
                className={props.descriptionStyle}
                dangerouslySetInnerHTML={{ __html: props.cardDescription }}
            />
            <button
                className={props.moreButtonStyle}
                onClick={props.handleVisibilityClick}
            >
                {props.buttonText}
            </button>
            {props.externalLink ?
                <a 
                    className="activityLink" 
                    target="__blank"
                    href={props.externalLink}>
                    <div className="externalLinkDiv">
                        <img className="externalLinkIcon" src={externalLink} alt="External Link Icon" />
                        <span>Go to Activity</span>
                    </div>
                </a>
                : null
            }
        </div>
    );
});

ActivityCard.defaultProps = {
    cardName: 'Missing card name',
    cardDescription: 'Missing card description',
    cardTags: 'Missing card tags',
    descriptionStyle: 'cardDescription',
    buttonText: 'Missing button text',
    moreButtonStyle: 'visibilityButton',
    activityCardText: {
        grades: 'GRADES:',
        targetSkills: 'TARGET SKILLS:',
        types: 'TYPE',

    },
};

ActivityCard.propTypes = {
    actvityCardText: PropTypes.object,
    cardName: PropTypes.string,
    cardDescription: PropTypes.string,
    externalLink: PropTypes.string,
    buttonText: PropTypes.string,
    cardTags: PropTypes.string,
    descriptionStyle: PropTypes.string,
    moreButtonStyle: PropTypes.string.isRequired,
    handleVisibilityClick: PropTypes.func.isRequired,
};

export default ActivityCard;




// WEBPACK FOOTER //
// ./src/components/ActivityCard.jsx